import { useRef } from "react";
import api, { apiErr } from "../lib/api";
import { toast } from "sonner";
import { Download, Upload, FileSpreadsheet } from "lucide-react";

export function ImportExport({ collection, onDone }) {
  const csvRef = useRef();
  const xlsxRef = useRef();

  const dl = (data, name) => {
    const u = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = u; a.download = name; a.click();
  };
  const expCsv = async () => { try { const r = await api.get(`/export/${collection}`, { responseType: "blob" }); dl(r.data, `${collection}.csv`); toast.success("Exported CSV"); } catch (e) { toast.error(apiErr(e)); } };
  const expXlsx = async () => { try { const r = await api.get(`/export/${collection}?fmt=xlsx`, { responseType: "blob" }); dl(r.data, `${collection}.xlsx`); toast.success("Exported Excel"); } catch (e) { toast.error(apiErr(e)); } };
  const impCsv = async (ev) => {
    const f = ev.target.files[0]; if (!f) return;
    const text = await f.text();
    try { const r = await api.post(`/import/${collection}`, { csv: text }); toast.success(`Imported: ${r.data.created} new, ${r.data.updated} updated`); onDone && onDone(); } catch (e) { toast.error(apiErr(e)); }
    ev.target.value = "";
  };
  const impXlsx = async (ev) => {
    const f = ev.target.files[0]; if (!f) return;
    const buf = await f.arrayBuffer();
    const bytes = new Uint8Array(buf);
    let bin = "";
    for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    const b64 = btoa(bin);
    try { const r = await api.post(`/import-xlsx/${collection}`, { b64 }); toast.success(`Imported: ${r.data.created} new, ${r.data.updated} updated`); onDone && onDone(); } catch (e) { toast.error(apiErr(e)); }
    ev.target.value = "";
  };
  const btn = "inline-flex items-center gap-1.5 bg-[#F4F6FA] hover:bg-[#DCE2EA] border border-[#DCE2EA] rounded-full px-3 py-1.5 text-xs font-semibold text-[#1F2733]";

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-[10px] font-bold uppercase tracking-wider text-[#98A2AF]">Export</span>
      <button data-testid={`export-${collection}-btn`} onClick={expCsv} className={btn}><Download className="h-3.5 w-3.5" /> CSV</button>
      <button data-testid={`export-${collection}-xlsx-btn`} onClick={expXlsx} className={btn}><FileSpreadsheet className="h-3.5 w-3.5" /> Excel</button>
      <span className="text-[10px] font-bold uppercase tracking-wider text-[#98A2AF] ml-1">Import</span>
      <button data-testid={`import-${collection}-btn`} onClick={() => csvRef.current.click()} className={btn}><Upload className="h-3.5 w-3.5" /> CSV</button>
      <button data-testid={`import-${collection}-xlsx-btn`} onClick={() => xlsxRef.current.click()} className={btn}><Upload className="h-3.5 w-3.5" /> Excel</button>
      <input ref={csvRef} type="file" accept=".csv" className="hidden" onChange={impCsv} />
      <input ref={xlsxRef} type="file" accept=".xlsx" className="hidden" onChange={impXlsx} />
    </div>
  );
}
